








































import { Component, Vue, Prop } from 'vue-property-decorator';
import { mapState } from 'vuex';

import ChevronRightIcon from 'mdi-vue/ChevronRight';

@Component({
  components: {
    ChevronRightIcon,
  },
  computed: mapState(['sidebarCollapsed']),
})
export default class SidebarItem extends Vue {
  @Prop({ required: true }) title!: string;
  @Prop(String) image!: string;
  @Prop(Boolean) hasChild!: boolean;
  @Prop(String) to!: string;
  @Prop(Boolean) active!: boolean;
  @Prop(Boolean) opened!: boolean;
  @Prop({ default: 0 }) level!: number;

  sidebarCollapsed!: boolean;

  click() {
    this.$emit('toggle');
  }

  getImage() {
    const images = require.context('@/assets/sidebar', false, /\.svg$/);
    return images(`./${this.image}`);
  }
}
